import type { TelopFont } from '@shared/types'

/**
 * P10-1 (2026-09-06): the「フォント」select shown on Title/Label/EndCard/
 * FreeText inspectors, and on TabTemplate's autoEdit-wide titleFont select.
 * Display order per P10_PHASE1.md §2 item 5: "表示: ゴシック／明朝／手書き。
 * 値: gothic/mincho/hand". `Record` (not an array) so a caller can render a
 * subset in a fixed order via `Object.keys` without re-declaring the labels.
 */
export const FONT_SELECT_LABEL: Record<TelopFont, string> = {
  gothic: 'ゴシック',
  mincho: '明朝',
  hand: '手書き風',
}

export const FONT_SELECT_ORDER: TelopFont[] = ['gothic', 'mincho', 'hand']
